import * as React from "react";
import Clipboard from "clipboard";

class ClipboardButton extends React.Component {
  static defaultProps = {
    label: "Copy to clipboard",
    copyMessage: "Copied!"
  };

  state = {
    label: this.props.label
  };

  clipboard;
  button;

  componentDidMount() {
    this.clipboard = new Clipboard(this.button);
    this.clipboard.on("success", this.displayTooltip);
  }

  displayTooltip = () => {
    this.setState({ label: this.props.copyMessage });
  };

  resetTooltip = () => {
    this.setState({ label: this.props.label });
  };

  render() {
    return (
      <button
        ref={b => (this.button = b)}
        className="btn btn-outline-info invitation-code tooltipped tooltipped-w"
        data-clipboard-text={this.props.text}
        aria-label={this.state.label}
        onMouseOut={this.resetTooltip}
      >
        {this.props.text}
      </button>
    );
  }
}

export default ClipboardButton;
